import request from "@/utils/request";
import URL from "@/api/baseUrl";

export default class VipAirOrder {
  static list(params = {}, config = {}) {
    return request.get(`${URL.vip}/vip-air-order/list`, params, config);
  }

  static detail(id) {
    return request.get(`${URL.vip}/vip-air-order/${id}`);
  }

  static statusCount(params = {}) {
    return request.get(`${URL.vip}/vip-air-order/statusCount`, params);
  }

  static export(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/export`, data, { responseType: "blob" });
  }

  static excelOrderMarkList(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/excelOrderMarkList`, data, { responseType: "blob" });
  }

  static excelOrderMarkA4List(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/excelOrderMarkA4List`, data, { responseType: "blob" });
  }

  static excelOrderReceipt(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/excelOrderReceipt`, data, { responseType: "blob" });
  }

  static downloadScanningImage(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/downloadScanningImage`, data, { responseType: "blob" });
  }

  static downloadPod(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/downloadPod`, data, { responseType: "blob" });
  }

  static traceExport(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/traceExport`, data, { responseType: "blob" });
  }

  static queryVipAirTraceList(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/queryVipAirTraceList`, data);
  }

  static inWarehouseDataPrint(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/inWarehouseDataPrint`, data, { responseType: "blob" });
  }

  static customerInfo() {
    return request.get(`${URL.vip}/vip-air-order/customer-info`);
  }

  static add(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/add`, data);
  }

  static submitAudit(data = {}) {
    return request.post(`${URL.vip}/vip-air-order/submitAudit`, data);
  }

  static edit(data = {}) {
    return request.put(`${URL.vip}/vip-air-order/edit`, data);
  }
}
